


function LastWorksCard({ works,index }) {
  
  
    
  return (
    
        <>
        {index < 3 ? (
            <div className="cardLastWorks tohiden2">
           <div className="detail">
           <span className="lw_time">{works.time}</span>|<span className="lw_enterprise">{works.enterprise}</span>|<span className="lw_detail">{works.detail}</span>
           
           </div>
           </div>
        ) : (
            <div className="cardLastWorks tohiden ">
            <div className="detail">
            <span className="lw_time">{works.time}</span>|<span className="lw_enterprise">{works.enterprise}</span>|<span className="lw_detail">{works.detail}</span>
            </div>
            </div>
        )}

        </>
        
       
    

  );
}

export default LastWorksCard;